import { router } from "expo-router"
import { View } from "react-native"
import { useResetPasswordMutation } from "@/queries/user"
import { useState } from "react"
import FeedbackTextInput from "@/components/input/FeedbackTextInput"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import { showErrorToast, showSuccessToast } from "@/components/toasts/AppToast"
import * as signInEvents from "@/analytics/events/sign-in"
import { useViewedCallback } from "@/analytics/react"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import Head from "expo-router/head"
import BFText, { Body, H2 } from "@/components/standard/BFText"
import { A } from "@/components/standard/Html"

export default function ResetPassword() {
  const resetPWMutation = useResetPasswordMutation()
  const [email, setEmail] = useState<string>("")

  useViewedCallback(() => {
    setStatusBarStyle("light")
    signInEvents.signInViewed()
  })

  const onResetPassword = () => {
    resetPWMutation.mutate(
      {
        email,
      },
      {
        onSuccess: () => {
          showSuccessToast({
            title: "Check your email",
            message: `If you have an account, we’ve emailed you a link to reset your password `,
            visibilityTime: 5000,
            autoHide: true,
          })
          if (router.canGoBack()) {
            router.back()
          } else {
            router.replace("/login")
          }
        },
        onError: (error) => {
          const errorResponse = (error as any)?.response
          if (errorResponse.errors) {
            showErrorToast({
              title: "Reset Email Error",
              message: errorResponse.errors[0].message,
            })
          }
        },
      }
    )
  }

  return (
    <>
      <Head>
        <title>Backflip - Reset Password</title>
      </Head>
      <View className={"flex-1 justify-between"}>
        <View>
          <View className={"flex flex-col"}>
            <View className="pt-10 pb-6 gap-3">
              <H2 className="text-white">Forgot Password</H2>
              <Body className="text-white">
                Enter your registered email address and we’ll email you a link
                to reset it.
              </Body>
            </View>
            <FeedbackTextInput
              placeholder="Email"
              value={email}
              onChange={setEmail}
              keyboardType="email-address"
              returnKeyType="done"
              testID="login-email-text-input"
            />
          </View>

          <BFText className="text-white text-[12px] font-spacegrotesk text-center mb-10">
            Don&apos;t have an account?&nbsp;
            <BFText
              className="underline text-teal font-spacegrotesk"
              onPress={() => {
                router.push("/register")
              }}
            >
              Sign Up
            </BFText>
          </BFText>
        </View>

        <View>
          <PrimaryButton
            testID="reset-password-button"
            title={"Reset Password"}
            onPress={onResetPassword}
            disabled={email === ""}
          />
          <BFText className="text-white text-[10px] font-spacegrotesk text-center m-[6px]">
            <A
              className="underline text-teal font-spacegrotesk"
              href="https://dobackflip.com/backflip-terms-of-use-agreement/"
            >
              Terms of Use
            </A>
            &nbsp;and&nbsp;
            <A
              className="underline text-teal font-spacegrotesk"
              href="https://dobackflip.com/privacy/"
            >
              Privacy Policy
            </A>
          </BFText>
        </View>
      </View>
    </>
  )
}
